export default "/images/vendor/flag-icon-css/flags/4x3/ps.svg?385ac1bdebf6347dcdfe796860404371";